import { kenyaDestination } from './kenya';
import { tanzaniaDestination } from './tanzania';
import { rwandaDestination } from './rwanda';
import { zanzibarDestination } from './zanzibar';
import { southAfricaDestination } from './southafrica';

export const DESTINATIONS = {
  kenya: kenyaDestination,
  tanzania: tanzaniaDestination,
  rwanda: rwandaDestination,
  zanzibar: zanzibarDestination,
  southafrica: southAfricaDestination
};

export {
  kenyaDestination,
  tanzaniaDestination,
  rwandaDestination,
  zanzibarDestination,
  southAfricaDestination
};